var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDirection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 0.999951C14 0.447693 14.4477 0 15 0C15.5523 5.96017e-08 16 0.447694 16 0.999951L16 10.5853L18.2929 8.29249C18.6834 7.90198 19.3166 7.90198 19.7071 8.29249C20.0976 8.683 20.0976 9.31613 19.7071 9.70664L15.7071 13.7064C15.3166 14.0969 14.6834 14.0969 14.2929 13.7064L10.2929 9.70664C9.90237 9.31613 9.90237 8.683 10.2929 8.29249C10.6834 7.90198 11.3166 7.90198 11.7071 8.29249L14 10.5853L14 0.999951ZM4.29289 0.292879C4.68342 -0.0976262 5.31658 -0.0976263 5.70711 0.292879L9.70711 4.29268C10.0976 4.68319 10.0976 5.31632 9.70711 5.70683C9.31658 6.09733 8.68342 6.09733 8.29289 5.70683L6 3.41405V12.9994C6 13.5516 5.55228 13.9993 5 13.9993C4.44772 13.9993 4 13.5516 4 12.9994V8.70668V3.41405L1.70711 5.70683C1.31658 6.09733 0.683417 6.09733 0.292893 5.70683C-0.0976311 5.31632 -0.0976311 4.68319 0.292893 4.29269L4.29289 0.292879Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirection);
export default __webpack_public_path__ + "static/media/direction.d110469b092a2a512bbe6eb74f6aa5fa.svg";
export { ForwardRef as ReactComponent };